import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { CardioOrResistance, Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class ThreeBodyGroupsFilter implements IExerciseSelectionFilter {
    public description: string = 'Returns only exercises that match users 3 body group setting';
    public name: string = 'ThreeBodyGroupsFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[],
                  workoutStartDate: Date): Exercise[] {
        const threeBodyGroupsSetting = userWorkoutSettings.threeBodyGroups;

        // none selected should ignore filter
        if (threeBodyGroupsSetting == null || threeBodyGroupsSetting.length === 0) {
            return inputExercises;
        }
        const smallBodyGroups = Exercise.getSmallBodyGroupsFor3BodyGroups(threeBodyGroupsSetting).sort();

        const shouldUseStrictBodyGroups = userWorkoutSettings.cardioOrResistance === CardioOrResistance.Resistance
                                          && !userWorkoutSettings.allowBagContact;
        if (shouldUseStrictBodyGroups) {
            // for Build the body group(s) if there is any group in exercise NOT in setting ingore
            return inputExercises.filter((exercise) => {
                const settingsThreeBodyGroups = threeBodyGroupsSetting;
                const exerciseThreeBodyGroups = Exercise.get3BodyGroups(exercise.bodyGroups).map((b) => b as string);

                const exerciseBodyGroupsNotFoundInSettings = exerciseThreeBodyGroups.find(
                    (bg) => settingsThreeBodyGroups.find((bgs) => bgs === bg) === undefined);

                return exerciseBodyGroupsNotFoundInSettings === undefined;
            });

        } else {
            // for Burn at least one body group in settings must match at least one in the exercise
            return inputExercises.filter((e) => {
                const matched = e.bodyGroups.filter((bodyGroup) =>
                    smallBodyGroups.indexOf(bodyGroup) !== -1,
                );

                return matched.length > 0;
            });
        }
    }
}
